import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as pageActions from 'actions/pageActions';
import * as surveyActions from 'actions/surveyActions';
import * as timerActions from 'actions/timerActions';
import HowItWorksSteps from 'components/HowItWorksSteps';
import { EMPLOYEE } from 'constants/users';
import i18n from 'i18next';
import { Trans } from 'react-i18next';
import { MOTIVATOR, PRELIMINARY_QUESTIONS } from 'constants/pageDictionary';
import TimerText from './TimerText';
import StartMotivatorAssessment from './StartMotivatorAssessment';
import './Welcome.scss';
import { hasStartedSurvey } from '../../utils';


class Welcome extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: false,
            termsAndPolicyIsChecked: false,
            hideTermsAndPolicyCheckbox: false
        };
    }

    componentDidMount() {
        // ATTUNED-3150
        if (hasStartedSurvey(this.props.user)) {
            this.startMotivatorAssessment();
        }

        if (window.location.search.includes('skip_terms=true')) {
            this.setState({ termsAndPolicyIsChecked: true, hideTermsAndPolicyCheckbox: true });
        }
    }

    render() {
        const { user } = this.props;
        const { employees, candidate } = this.renderTermsAndPolicy();

        return (
            <section className='how-it-works-section' style={ { height: user.get('respondentRoleName') !== EMPLOYEE || user.get('has_engagement_module') !== true ? '100vh' : 'inherit' } }>
                <title className='how-it-works-header-container'>
                    <h3>{ i18n.t('welcome.how_it_works') }</h3>
                    {user.get('respondentRoleName') === EMPLOYEE &&
                    user.get('has_engagement_module') === true && // ATTUNED-3090
                    (!user.get('is_retake') || (user.get('is_retake') && user.get('has_pending_batch_survey'))) ?
                        <p className='get-started-in-just-three-steps'>{ i18n.t('welcome.get_started_in_just_three_steps') }</p> : null}
                </title>
                {user.get('respondentRoleName') === EMPLOYEE && user.get('has_engagement_module') === true &&
                (!user.get('is_retake') || (user.get('is_retake') && user.get('has_pending_batch_survey'))) ?
                    <HowItWorksSteps selectedStep={ 1 } /> : null}
                <p className='attuned-intrinsic-motivator-message'>{i18n.t('motivator.attuned_intrinsic_motivator_survey_was_developed') }</p>
                <Trans i18nKey='motivator.please_note_that_this_is_not_personality_test' parent='p' className='attuned-intrinsic-motivator-message' components={ { b: <b /> } } />
                <div className='survey-form'>
                    <TimerText />
                    <StartMotivatorAssessment
                        user={ user }
                        employees={ employees }
                        candidate={ candidate }
                        hideTermsAndConditions={ this.state.hideTermsAndPolicyCheckbox }
                        onStartAssessment={ this.onStartAssessment }
                        isLoading={ this.state.isLoading }
                        termsAndPolicyIsChecked={ user.get('userRoleId') === 1 ? true : this.state.termsAndPolicyIsChecked }
                        handleClick={ this.handleClick } />
                </div>
            </section>
        );
    }

    onStartAssessment = () => {
        if (hasStartedSurvey(this.props.user)) {
            this.startMotivatorAssessment();
        } else {
            this.skipQuestionsBySurveyOptions();
        }
    };

    startMotivatorAssessment = async () => {
        await this.props.actions.startSurvey();
        this.props.actions.startTimer(new Date());
        this.props.actions.goToPage(MOTIVATOR);
    };

    handleClick = (event) => {
        this.setState({ termsAndPolicyIsChecked: event.target.checked });
    };

    renderTermsAndPolicy = () => {
        const { user } = this.props;
        const host = 'https://www.attuned.ai/';
        const tc = (
            <span onClick={ () => window.open(`${ host }terms${ i18n.language === '日本語' ? '-jp' : '' }`) } className='tou'>{ i18n.t('welcome.terms_conditions') }</span>);
        const pp = (
            <span
                onClick={ () => {
                    const link = i18n.t('welcome.privacy_policy_link') !== 'welcome.privacy_policy_link'
                        ? i18n.t('welcome.privacy_policy_link')
                        : `${ host }privacy-policy${ i18n.language === '日本語' ? '-jp' : '' }`;
                    window.open(link);
                } }
                className='pp'>
                { i18n.t('welcome.privacy_policy') }
            </span>);
        const employees = (
            <span>{ tc }{ i18n.t('welcome.and') }{ pp }{ user.get('languageId') === 3 ? 'に同意します。' : '' }</span>);
        const candidate = (
            <span>{ employees }{ i18n.t('welcome.candidate_term') }</span>);
        return { employees, candidate };
    }

    skipQuestionsBySurveyOptions = () => {
        if (this.props.surveyOptions.get('ask_respondent_tenure')) {
            return this.props.actions.goToPage(PRELIMINARY_QUESTIONS, {
                currentQuestionIdx: 0
            });
        }

        if (this.props.surveyOptions.get('ask_respondent_age')) {
            return this.props.actions.goToPage(PRELIMINARY_QUESTIONS, {
                currentQuestionIdx: 1
            });
        }

        if (this.props.surveyOptions.get('ask_respondent_gender')) {
            return this.props.actions.goToPage(PRELIMINARY_QUESTIONS, {
                currentQuestionIdx: 2
            });
        }

        return this.startMotivatorAssessment();
    }
}

Welcome.propTypes = {
    user: PropTypes.object,
    actions: PropTypes.object,
    surveyOptions: PropTypes.object
};

Welcome.defaultProps = {
    user: null,
    actions: null,
    surveyOptions: {}
};

const mapStateToProps = (state) => ({
    surveyOptions: state.surveyOptionsReducer,
    user: state.respondentNameReducer
});

const mapDispatchToProps = (dispatch) => ({
    actions: bindActionCreators(Object.assign({}, pageActions, surveyActions, timerActions), dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(Welcome);
